$(document).ready(function() {

    // ON show modal populate email
    var $newsletter_modal = $('#modal-newsletter');

    $newsletter_modal.on('show.bs.modal', function () {
        $newsletter_modal.find('#newsletter-email').val($('#input-newsletter').val());
    })

    $('#form-newsletter').on('submit', function () {
        $newsletter_modal.modal({
            show: true,
            backdrop: 'static',
            keyboard: true
        });
        return false;
    })
});
